var React = require('react');

function SmallLightning (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M60.318 31.716 29.788 13.45c-2.756-1.649-5.854 1.585-3.823 3.991L37.966 31.66a2.597 2.597 0 0 1 0 3.386L17.63 59.138c-1.192 1.412-.623 3.504 1.145 4.204l59.187 23.43c2.78 1.1 5.274-2.027 3.373-4.227L52.46 49.135a2.598 2.598 0 0 1-.006-3.427l8.563-9.984c1.085-1.265.758-3.135-.7-4.008Z","stroke":"#fff","strokeWidth":"4","strokeLinejoin":"round"}));
}

SmallLightning.defaultProps = {"width":"100","height":"100","fill":"none"};

module.exports = SmallLightning;

SmallLightning.default = SmallLightning;
